import React from 'react';
import { Helmet } from 'react-helmet';
import { translate } from '../../i18n';
import { ITranslations } from '../../i18n/config';
import skyline from '../../images/skyline.png';
import skyline2x from '../../images/skyline@2x.png';
import Header from '../Header';
import Typography from '../Typography';
import './style.scss';

interface BannerLayoutProps {
  title: string;
  metaTitle?: ITranslations;
  metaDescription?: ITranslations;
}

const BannerLayout: React.FC<BannerLayoutProps> = ({
  children,
  metaTitle,
  metaDescription,
  title,
}) => {
  return (
    <>
      <Header />
      <div className="ckp-o-banner-layout">
        <Helmet>
          <title>{metaTitle ? translate(metaTitle) : title}</title>
          {metaDescription && <meta name="description" content={translate(metaDescription)} />}
        </Helmet>

        <figure className="m-image ckp-o-banner-layout__header__image">
          <img src={skyline2x} srcSet={`${skyline} 0.5x, ${skyline2x} 1x`} />
        </figure>

        <div className="u-container">
          <div className="row ckp-o-banner-layout__content">
            <header className="col-xs-12 ckp-o-banner-layout__header">
              <Typography variant="h1" as="h1">
                {title}
              </Typography>
            </header>

            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerLayout;
